@if ((value === '' || (error$ | async)) && hasExtendedExplore && (isExplore$ | async) === false && (hasTrial$ | async) === false) {
    <div class="box" [ngClass]="{ 'lg:!tw-w-[42.25rem]': hasCustomLogo }" @Grow>
        @if (skillCategoryLoaded$ | async) {
            <div @Grow>
                <app-search-skills-categories [skillCategories]="availableSkillCategories" />
            </div>
        } @else {
            <div @Grow class="tw-h-24">
                <app-loader loaderType="cover" overlayColor="white" />
            </div>
        }
    </div>
}

@if (value !== '' && (error$ | async) === false) {
    <div class="box" [ngClass]="{ 'xl:!tw-w-[42.25rem]': hasCustomLogo }" @Container @Grow>
        @if ((loading$ | async) === false) {
            <div aria-live="polite" class="tw-sr-only">{{ 'navbar.search-results-for' | translate: { value } }}</div>
            <div appList [id]="listId" @Grow>
                @if (((isExplore$ | async) === false && hasContent) || hasRelatedTerms) {
                    @if (hasRelatedTerms) {
                        <ul [style.padding-bottom.rem]="(isExplore$ | async) === false && hasContent ? 1.375 : 0">
                            @for (related of results.relatedTerms; track related.term) {
                                <li>
                                    <a
                                        appSearch
                                        [term]="related.term"
                                        [routerLink]="related.route"
                                        [queryParams]="related.queryParams"
                                        [class.no-content]="(isExplore$ | async) === false && hasContent === false"
                                        appListItem
                                        [attr.data-test]="'search-term-{{$index}}'"
                                    >
                                        {{ related.term }}
                                    </a>
                                </li>
                            }
                        </ul>
                    }

                    @if (hasContent && (isExplore$ | async) === false) {
                        <div class="title">{{ 'v3-header-search-content-to-explore' | translate }}</div>
                        <ul>
                            @for (content of results.contents; track $index) {
                                <li>
                                    <a
                                        class="content-box"
                                        appListItem
                                        [appRedirect]="{ type: content.type, id: content.id, missionId: content.missionId }"
                                        [id]="content.id"
                                        tabindex="0"
                                        [ngSwitch]="content.type"
                                        [attr.data-test]="'search-content-{{$index}}'"
                                    >
                                        <app-path-result *ngSwitchCase="'path'" [path]="content" />
                                        <app-mission-result *ngSwitchCase="'mission'" [mission]="content" />
                                        <app-course-result *ngSwitchCase="'course'" [course]="content" />
                                    </a>
                                </li>
                            }
                        </ul>
                    }
                } @else {
                    <div aria-live="polite" class="not-found text-center">{{ 'v3-explore-no-results-found' | translate }}</div>
                }
            </div>
        } @else {
            <div @Grow class="tw-h-24">
                <app-loader loaderType="cover" overlayColor="white" />
            </div>
        }
    </div>
}
